import { Stack, Box, useTheme } from "@mui/material";

const SeverityCellRenderer = (params: { value: string }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Normalize the value to Title Case to match keys (e.g. "critical" -> "Critical")
  const severityValue = params.value ? params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase() : "";

  const severityStyles: any = {
    Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };

  return (
    <div className="ag-center">
      <Stack direction="row" alignItems="center">
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: "22px",
            px: 1.5,
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: 600,
            textTransform: "capitalize",
            bgcolor: severityStyles[severityValue]?.bgcolor || (isDarkMode ? "rgba(107, 114, 128, 0.15)" : "#f5f5f5"),
            color: severityStyles[severityValue]?.color || (isDarkMode ? "#9CA3AF" : "#666666"),
            position: "relative",
            pl: 2.5,
            "&::before": {
              content: '""',
              position: "absolute",
              left: 8,
              top: "50%",
              transform: "translateY(-50%)",
              width: 8,
              height: 8,
              bgcolor: severityStyles[severityValue]?.color || (isDarkMode ? "#9CA3AF" : "#666666"),
              borderRadius: "50%",
            },
          }}
        >
          {severityValue}
        </Box>
      </Stack>
    </div>
  );
};

export default SeverityCellRenderer;
